import React from 'react';
import { StyledComponentProps } from '~/types/material-ui';
import { useStyles } from './style';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import EcosystemTypeChip from './ecosystem-type-chip';
import { EcosystemItemType } from '~/enums/ecosystem.enum';
import { EcosystemApp } from '~/utils/ecosystem.util';

interface Props extends StyledComponentProps<typeof useStyles> {
  ecosystemItem: EcosystemApp;
}

const EcosystemItem: React.FC<Props> = (props) => {
  const { ecosystemItem } = props;
  const { classes } = useStyles(undefined, { props: { classes: props.classes } });
  const { i18n } = useTranslation('common');

  if (!ecosystemItem.description[i18n.language]) {
    return null;
  }

  return (
    <div
      className={classes.container}
      onClick={() => {
        window.open(ecosystemItem.url, '_blank');
      }}
    >
      <div className={classes.content}>
        <div className={classes.header}>
          <img
            src={ecosystemItem.image}
            alt={ecosystemItem.name[i18n.language]}
            className="dark:invert"
          />
        </div>

        <Box display="flex">
          <div className={classes.chipContainer}>
            {ecosystemItem.types.map((type: string) => (
              <EcosystemTypeChip key={type} ecosystemType={type as EcosystemItemType} />
            ))}
          </div>
        </Box>

        <Typography className={classes.description}>
          {ecosystemItem.description[i18n.language]}
        </Typography>
      </div>
    </div>
  );
};

export default EcosystemItem;
